
<div class="modal fade" id="viewImageAction" tabindex="-1" role="dialog" aria-labelledby="viewImage" aria-hidden="true"
data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-xl" role="document" style="height:calc(100vh - 56px);">
    <div class="modal-content" style="height: calc(100vh - 56px);">
      <button class="no-border-btn doc-close-btn" data-dismiss="modal">
        <img src="../../../assets/images/cross-icon-3.svg" alt="cross-icon" width="24px" height="24px">
      </button>
      <div class="modal-body">
        <div class="row">
          <!-- <div class="col-12 details content-center">
            <img [src]="samplePicture" alt="sample-picture" class="img-fluid" style="height: calc(100vh - 80px);">
          </div> -->
          <div class="content-center details" (mouseenter)="imageZoom('myimage2', 'myresult2');" style="margin:auto">
            <img id="myimage2" [src]="samplePicture" class="img-fluid" alt="sample-picture" style="height: calc(100vh - 80px);">
            <div id="myresult2" class="img-zoom-result"></div>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="position: absolute; bottom: 0px; right: 0px;">
        <div class="row">
          <div class="col-auto ml-auto">
            <div class="content-center">
              <button class="btn-1 circle-btn red-border"  data-dismiss="modal" style="width:32px; height:32px" (click)="onRejectDoc()"
              [disabled]="!editAccess">
                <img src="../../../assets/images/cross-icon.svg" alt="cross-icon" width="21px" height="21px">
              </button>
              <button class="btn-1 ml-24 circle-btn green-border" data-dismiss="modal" style="width:32px; height:32px" (click)="onAcceptDoc()"
              [disabled]="!editAccess">
                <img src="../../../assets/images/tick-icon.svg" alt="tick-icon" width="21px" height="21px">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>